// Sentry должен инициализироваться раньше всего, поэтому импорт instrument.js — самой первой строкой.
import "./instrument";

// Критические UI-правила дублируются из index.html: PWA-кэш умеет держать
// старую оболочку (index.html) неделями, а бандл обновляется по хэшу — так
// фиксы липких focus-колец и мобильного зума доезжают гарантированно.
(() => {
  try {
    if (!document.getElementById('critical-ui-css')) {
      const st = document.createElement('style');
      st.id = 'critical-ui-css';
      st.textContent = `
        button:focus { outline: none; }
        button:focus-visible { outline: none; }
        button { user-select: none; -webkit-user-select: none; }
        html { -webkit-tap-highlight-color: transparent; }
        @media (max-width: 768px) { input, textarea, select { font-size: 16px !important; } }
      `;
      document.head.appendChild(st);
    }
  } catch { /* ignore */ }
})();

import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from './context/AuthContext.jsx';
import { SettingsProvider } from './context/SettingsContext.jsx';
import { PlayerProvider } from './context/PlayerContext.jsx';
import { CallProvider } from './context/CallContext.jsx';
import { TimerProvider } from './context/FocusTimerContext.jsx';
import { ToastProvider } from './components/ToastProvider.jsx';
import App from './App.jsx';
import { initAnalytics } from './analytics.js';

initAnalytics();

// Register the service worker in production so the app shell loads offline.
// (push.js also registers '/sw.js' when enabling notifications — same registration,
// this just guarantees the SW is active for every user, not only those with push on.)
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  // When a freshly deployed SW takes control, reload once so the open tab runs the new build.
  let _swRefreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (_swRefreshing) return;
    _swRefreshing = true;
    // Пометка переживёт перезагрузку: App покажет экран инициализации на свежей сборке.
    try { sessionStorage.setItem('app_updating', '1'); } catch {}
    window.location.reload();
  });
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((reg) => {
        // Proactively check for a new build: hourly and whenever the app regains
        // focus. reg.update() bypasses the HTTP cache for sw.js by spec, so a
        // fresh deploy reaches clients even behind aggressive proxies. When the
        // new SW activates, the controllerchange handler above reloads once.
        const check = () => { try { reg.update(); } catch { /* ignore */ } };
        setInterval(check, 60 * 60 * 1000);
        document.addEventListener('visibilitychange', () => { if (!document.hidden) check(); });
      })
      .catch(() => {});
  });
}

// Build marker — confirms which bundle is live (stamped at build time via VITE_APP_VERSION).
console.log('[prep_app] build', import.meta.env.VITE_APP_VERSION || 'dev');

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <SettingsProvider>
      <ToastProvider>
        <AuthProvider>
          <PlayerProvider>
            <CallProvider>
              <TimerProvider>
                <App />
              </TimerProvider>
            </CallProvider>
          </PlayerProvider>
        </AuthProvider>
      </ToastProvider>
    </SettingsProvider>
  </React.StrictMode>
);